/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  GetTotalApiV1NotificationsFeedUserEventTotalGetQueryResponse,
  GetTotalApiV1NotificationsFeedUserEventTotalGetHeaderParams,
  GetTotalApiV1NotificationsFeedUserEventTotalGet422,
} from '../../types/GetTotalApiV1NotificationsFeedUserEventTotalGet.ts'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getTotalApiV1NotificationsFeedUserEventTotalGetQueryKey = () => [{ url: '/api/v1/notifications_feed_user_event/total/' }] as const

export type GetTotalApiV1NotificationsFeedUserEventTotalGetQueryKey = ReturnType<typeof getTotalApiV1NotificationsFeedUserEventTotalGetQueryKey>

/**
 * @summary Get Total
 * {@link /api/v1/notifications_feed_user_event/total/}
 */
export async function getTotalApiV1NotificationsFeedUserEventTotalGet(
  headers?: GetTotalApiV1NotificationsFeedUserEventTotalGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetTotalApiV1NotificationsFeedUserEventTotalGetQueryResponse,
    ResponseErrorConfig<GetTotalApiV1NotificationsFeedUserEventTotalGet422>,
    unknown
  >({ method: 'GET', url: `/api/v1/notifications_feed_user_event/total/`, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

export function getTotalApiV1NotificationsFeedUserEventTotalGetQueryOptions(
  headers?: GetTotalApiV1NotificationsFeedUserEventTotalGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getTotalApiV1NotificationsFeedUserEventTotalGetQueryKey()
  return queryOptions<
    GetTotalApiV1NotificationsFeedUserEventTotalGetQueryResponse,
    ResponseErrorConfig<GetTotalApiV1NotificationsFeedUserEventTotalGet422>,
    GetTotalApiV1NotificationsFeedUserEventTotalGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getTotalApiV1NotificationsFeedUserEventTotalGet(headers, config)
    },
  })
}

/**
 * @summary Get Total
 * {@link /api/v1/notifications_feed_user_event/total/}
 */
export function useGetTotalApiV1NotificationsFeedUserEventTotalGet<
  TData = GetTotalApiV1NotificationsFeedUserEventTotalGetQueryResponse,
  TQueryData = GetTotalApiV1NotificationsFeedUserEventTotalGetQueryResponse,
  TQueryKey extends QueryKey = GetTotalApiV1NotificationsFeedUserEventTotalGetQueryKey,
>(
  headers?: GetTotalApiV1NotificationsFeedUserEventTotalGetHeaderParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetTotalApiV1NotificationsFeedUserEventTotalGetQueryResponse,
        ResponseErrorConfig<GetTotalApiV1NotificationsFeedUserEventTotalGet422>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getTotalApiV1NotificationsFeedUserEventTotalGetQueryKey()

  const query = useQuery(
    {
      ...getTotalApiV1NotificationsFeedUserEventTotalGetQueryOptions(headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetTotalApiV1NotificationsFeedUserEventTotalGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}